import React from 'react';
import { Route } from 'react-router-dom';

import Home from './pages/Home/Home';
import Markets from './pages/Markets/Markets';
import Settings from './pages/Settings/Settings';
import Contact from './pages/Contact/Contact';
// import NotFound from './pages/404';

/* Main content component */
const Main = () => (
  <main>
      <Route exact path="/" component={Home} />
      <Route path="/markets" component={Markets} />
      <Route path="/settings/" component={Settings} />
      <Route path="/contact" component={Contact} />
  </main>
)

export default Main



// WEBPACK FOOTER //
// ./src/components/Main.js